module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAjCAYAAABLuFAHAAABIElEQVRIS+2VIU8DQRSEv6EWHAnVEAyB0v4A0qBIMMiSIHAIECT9HySoEkwVqg6BwJGK6gZkbSsbfsKQLb3keuwW6hD3zCX7dt5mZ2fmRKJsvwLbwKWkQWybloCHwCHQlNQvwd8MlITllGC7FEnEGaVI/otIPoB94FjSWzTDbJ8AG5HmKbAJvADTQr8CDGT7CnhMpWhifQzUZiKxHaL1aIUBLUm9DHwABAuu/WFAX1JzIcNs3wO3v4AN1CW9F8GBtBGwtWRAR9JN1l8whu0L4CkB/gR2JIVvPHpthzed3alQ15Ie8ms/LGl7Dwh3Cm+Z1VBSozgt6mfbd0A7tzn6p0yB1+fkVYGepFZUnilmbZ8DXWBX0mQl8Fx5Z5KeUwd8AekIsUyFTB3wAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/arrow-down.png
// module id = MHxL
// module chunks = 1